import { NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { DetourComponent } from '../../../shared/components';
import { TranslationPipe } from '../../../shared/pipes';
import { Connection } from '../../map/models';

@Component({
  selector: 'app-connection',
  standalone: true,
  imports: [NgIf, DetourComponent, TranslationPipe],
  templateUrl: './connection.component.html'
})
export class ConnectionComponent implements OnInit {
  @Input() connection: Connection = new Connection;

  isDetour = false;
  delay: number | undefined = undefined;
  iconClass: string = '';
  prefferedName: string = '';

  ngOnInit() {
    this.iconClass = this.getIconClass();
    this.isDetour = this.connection.isDetour === true;
    if (!this.connection.prefferedName) {
      const conn = new Connection();
      conn.init(this.connection);
      this.connection = conn;
    }
    this.prefferedName = this.connection.prefferedName(false);
  }
  
  getIconClass(): string {
    if (this.connection.vehicleType == 'V')
      return 'K';
    else if (this.connection.lineType === 'A')
      return 'M';

    return 'S';
  }
}

